module.exports = __webpack_public_path__ + "img/sw03.164e9c1e.jpg";